import * as types from './types'
import moment from 'moment'
import store from '@/store'
import globals from '@/plugins/globals.js'

export default {
  [types.RESET_PUBNUB](state) {
    if (state.pubnub) {
      state.pubnub.removeListener(state.listener)
    }
    state.pubnub = null
    state.pubnubTimestamp = null
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.RESET_CHANNELS](state) {
    state.channels = []
    state.firmCounts = []
  },
  [types.RESET_CHANNELINFO](state) {
    state.channelInfo = null
    state.messages = []
  },
  [types.SET_PUBNUB](state, data) {
    // set the PubNub chat service
    let profile = store.getters['auth/profile']
    state.listener = {
      status: function(status) {
        console.log('Chat: PubNub Status', status)
      },
      message: function(message) {
        console.log('Chat: PubNub Message', message)
        if (message) {
          if (state.membership) {
            if (state.membership.data) {
              let found = state.membership.data.find(
                x => parseInt(x.channel.id) === parseInt(message.channel)
              )
              if (found) {
                store.dispatch('chat/setMessage', message)
                // TODO: dispatch a Firebase Push Notification via our API
              }
            }
          }
        }
      },
      presence: function(presence) {
        // console.log('Chat: Presence', presence)
      },
      signal: function(signal) {
        // console.log('Chat: PubNub Signals', signal)
        if (signal) {
          let member = ''
          if (state.channelInfo) {
            if (state.channelInfo.members) {
              let found = state.channelInfo.members.find(x => x.uuid === signal.publisher)
              if (found) {
                member = found.name
              }
            }
          }
          window.eventBus.$emit('chat-user-typing', {
            message: signal.message,
            member: member,
            guid: signal.publisher,
            channel: signal.channel
          })
        }
      }
    }
    if (state.pubnub) {
      state.pubnub.removeListener(state.listener)
    }
    state.pubnub = data.pubnub
    state.pubnub.addListener(state.listener)
    if (profile.groups) {
      if (profile.groups !== '1') {
        // subscribe to the channels (if not already)
        state.pubnub.subscribe({
          channelGroups: profile.groups.split(','),
          withPresence: true
        })
        console.log('Chat: subscribed')
      }
    }
  },
  [types.SET_PUBNUB_TIMESTAMP](state, timestamp) {
    if (timestamp) {
      state.pubnubTimestamp = timestamp
      console.log('Chat: logged in', state.pubnubTimestamp)
    }
  },
  [types.SET_MEMBERSHIP](state, membership) {
    state.membership = membership
    console.log('Chat (set membership): membership', membership)
  },
  async [types.GET_UNREAD](state) {
    let forCount = []
    state.membership = null
    let currentMembership = await state.pubnub.objects.getMemberships({
      include: {
        channelFields: true,
        customFields: true
      }
    })
    store.dispatch('chat/setMembership', currentMembership)
    if (currentMembership) {
      if (currentMembership.data) {
        // gather up the channel ids and tokens
        currentMembership.data.forEach(element => {
          forCount.push({
            id: element.channel.id,
            token: element.custom ? element.custom.lastReadTimetoken : state.pubnubTimestamp
          })
        })
      }
    }
    let messageCounts = null
    let channels = []
    let tokens = []
    if (forCount.length > 0) {
      forCount.forEach(element => {
        channels.push(element.id)
        tokens.push(element.token)
      })
      // call for counts
      messageCounts = await state.pubnub.messageCounts({
        channels: channels,
        channelTimetokens: tokens
      })
    }
    if (messageCounts) {
      console.log('Chat (get unread): got counts', {
        channels: channels,
        tokens: tokens,
        messageCounts: messageCounts
      })
      let counts = []
      Object.keys(messageCounts.channels).forEach(key =>
        counts.push({
          id: key,
          count: messageCounts.channels[key]
        })
      )
      store.dispatch('chat/setUnread', counts)
    }
  },
  [types.SET_UNREAD](state, counts) {
    state.unreadCounts = counts
    state.unreadCount = 0
    state.firmCounts = []
    // console.log('Chat (set unread): set channel counts', state.unreadCounts)
    if (state.unreadCounts) {
      if (state.unreadCounts.length > 0 && state.channels) {
        if (state.channels) {
          // loop through each channel and compare
          state.channels.forEach(channel => {
            let found = state.unreadCounts.find(
              x => parseInt(x.id) === parseInt(channel.calibrateEvent)
            )
            if (found) {
              channel.unreadCount = parseInt(found.count)
              state.unreadCount += parseInt(found.count)
            }
            found = state.firmCounts.find(x => parseInt(x.firm) === parseInt(channel.firm))
            if (!found) {
              state.firmCounts.push({
                firm: parseInt(channel.firm),
                name: channel.firmName,
                unreadCount: 0
              })
            }
          })
          state.firmCounts.forEach(firm => {
            let filtered = state.channels.filter(x => parseInt(x.firm) === parseInt(firm.firm))
            if (filtered) {
              let count = 0
              filtered.forEach(item => {
                count += parseInt(item.unreadCount)
              })
              firm.unreadCount = count
            }
          })
        }
        if (state.chatBar) {
          state.chatBar.forEach(channel => {
            let found = state.unreadCounts.find(x => parseInt(x.id) === parseInt(channel.id))
            if (found) {
              channel.unreadCount = parseInt(found.count)
            }
          })
        }
        if (state.channels.length === 0) {
          state.unreadCounts.forEach(element => {
            state.unreadCount += parseInt(element.count)
          })
        }
        console.log('Chat (set unread): updated channels', {
          unread: state.unreadCounts,
          channels: state.channels,
          totalUnread: state.unreadCount,
          firmCounts: state.firmCounts
        })
        window.eventBus.$emit('chat-refresh-groups')
      }
    }
  },
  async [types.SET_CHANNELS](state, data) {
    let addNew = []
    // chat channels
    state.channels = []
    state.firmCounts = []
    state.unreadCount = 0
    if (data) {
      state.channels = data
      if (state.channels) {
        // loop through each channel and compare
        state.channels.forEach(channel => {
          let found = state.unreadCounts.find(
            x => parseInt(x.id) === parseInt(channel.calibrateEvent)
          )
          if (found) {
            channel.unreadCount = parseInt(found.count)
            state.unreadCount += parseInt(found.count)
          }
          found = state.firmCounts.find(x => parseInt(x.firm) === parseInt(channel.firm))
          if (!found) {
            state.firmCounts.push({
              firm: parseInt(channel.firm),
              name: channel.firmName,
              unreadCount: 0
            })
          }
        })
        state.firmCounts.forEach(firm => {
          let filtered = state.channels.filter(x => parseInt(x.firm) === parseInt(firm.firm))
          if (filtered) {
            let count = 0
            filtered.forEach(item => {
              count += parseInt(item.unreadCount)
            })
            firm.unreadCount = count
          }
        })
        console.log('Chat: got Channels from API', {
          unreadCounts: state.unreadCounts,
          channels: state.channels,
          firmCounts: state.firmCounts
        })
      }
      window.eventBus.$emit('chat-refresh-groups')
    }
    // compare to see if user needs to join channels
    if (state.channels) {
      // loop through each channel and compare
      state.channels.forEach(channel => {
        if (state.membership) {
          if (state.membership.data) {
            let found = state.membership.data.find(
              x => parseInt(x.channel.id) === parseInt(channel.calibrateEvent)
            )
            // found = null
            if (found === undefined || found === null) {
              // add as new membership
              addNew.push({
                id: channel.calibrateEvent.toString(),
                custom: {
                  lastReadTimetoken: state.pubnubTimestamp,
                  calibrate: channel.calibrate.toString()
                }
              })
            }
          }
        }
      })
    }
    // add any new channels to the membership
    if (addNew.length > 0) {
      console.log('Chat (initial membership): add new channels', addNew)
      await state.pubnub.objects.setMemberships({
        channels: addNew,
        include: {
          channelFields: true
        }
      })
    }
  },
  async [types.SET_CHANNELINFO](state, data) {
    // chat channel info
    state.channelInfo = null
    if (data) {
      if (data.info.status === 200) {
        state.channelInfo = {
          id: data.data.calibrateEvent,
          members: [],
          memberCount: 0,
          ronumber: data.data.ronumber,
          firmName: data.data.firmName,
          vehicleInfo: `${data.data.year} ${data.data.make} ${data.data.model}`
        }
        // https://stackoverflow.com/questions/26287745/how-can-i-generate-a-list-of-random-shades-of-a-particular-color-e-g-random-s
        // http://jsbin.com/rafen/2/edit?html,css,js,output
        let hue = 210 // 180 = Cyan 210 = Azure 240 = Blue
        data.info.data.forEach(element => {
          state.channelInfo.members.push({
            uuid: element.uuid.id,
            name: element.uuid.name,
            email: element.uuid.email,
            profileUrl: element.uuid.profileUrl,
            color: `hsl(${hue}, ${globals.rand(30, 90)}%, ${globals.rand(40, 80)}%)`
          })
        })
        state.channelInfo.memberCount = data.info.data.length
        // notify presence
        let results = await state.pubnub.hereNow({
          channels: [data.data.calibrateEvent.toString()],
          includeUUIDs: true,
          includeState: true
        })
        console.log('Chat: got Channel Info', {
          channelInfo: state.channelInfo,
          hereNow: results
        })
      }
    }
  },
  [types.SET_MESSAGES](state, data) {
    // chat channel messages
    state.messages = []
    console.log('Chat: got Channel Messages', data)
    if (data) {
      let profile = store.getters['auth/profile']
      if (data.messages) {
        if (!globals.isEmpty(data.messages)) {
          if (data.messages) {
            let last = ''
            data.messages.forEach(element => {
              let type = 'received'
              if (data.isAdmin) {
                if (element.uuid === last) {
                  type = 'sent'
                }
              } else {
                if (element.uuid === profile.guid) {
                  type = 'sent'
                }
              }
              let member = ''
              let color = null
              if (state.channelInfo) {
                if (state.channelInfo.members) {
                  let found = state.channelInfo.members.find(x => x.uuid === element.uuid)
                  if (found) {
                    member = found.name
                    color = found.color
                  }
                }
              }
              let timetoken = parseFloat(element.timetoken) / 10000000
              state.messages.push({
                createdOn: moment.unix(timetoken).calendar(),
                name: null,
                type: type,
                message: element.message,
                isTitle: false,
                member: member,
                color: color,
                timetoken: element.timetoken
              })
              last = element.uuid
            })
          }
        }
      }
      // state.messages.reverse()
    }
    // console.log('Chat: processed Channel Messages', state.messages)
  },
  [types.SET_MESSAGE](state, message) {
    if (message) {
      if (state.channelInfo) {
        if (parseInt(state.channelInfo.id) === parseInt(message.channel)) {
          console.log('Chat: got New Channel Message', {
            messages: state.messages,
            message: message
          })
          let profile = store.getters['auth/profile']
          let type = 'received'
          if (message.publisher === profile.guid) {
            type = 'sent'
          }
          let member = ''
          let color = null
          if (state.channelInfo) {
            if (state.channelInfo.members) {
              let found = state.channelInfo.members.find(x => x.uuid === message.publisher)
              if (found) {
                member = found.name
                color = found.color
              }
            }
          }
          let found = state.messages.find(
            x => x.member === message.publisher && x.timetoken === message.timetoken
          )
          if (!found) {
            let timetoken = parseFloat(message.timetoken) / 10000000
            state.messages.push({
              createdOn: moment.unix(timetoken).calendar(),
              name: null,
              type: type,
              message: message.message,
              isTitle: false,
              member: member,
              color: color,
              timetoken: message.timetoken
            })
          }
          console.log('Chat: after New Channel Message', state.messages)
        }
      }
    }
  },
  [types.SET_CHATBAR](state, data) {
    if (data) {
      console.log('Chat: set Chat Bar', {
        data: data,
        membership: state.membership
      })
      switch (data.name) {
        case 'add':
          let found = state.membership.data.find(
            x => parseInt(x.channel.id) === parseInt(data.value)
          )
          if (found) {
            let there = null
            if (state.chatBar) {
              if (state.chatBar.length > 0) {
                there = state.chatBar.find(x => parseInt(x.id) === parseInt(data.value))
              }
            }
            if (!there) {
              state.chatBar.push({
                id: found.channel.id,
                description: found.channel.description,
                unread: 0
              })
            }
          }
          break
        case 'remove':
          state.chatBar = state.chatBar.filter(x => parseInt(x.id) !== parseInt(data.value))
          break
        case 'show':
          break
      }
      console.log('Chat: updated Chat Bar', state.chatBar)
    }
  },
  [types.USER_TYPING](state, data) {
    if (data) {
      let member = ''
      if (state.channelInfo) {
        if (state.channelInfo.members) {
          let found = state.channelInfo.members.find(x => x.uuid === data.publisher)
          if (found) {
            member = found.name
          }
        }
      }
      window.eventBus.$emit('chat-user-typing', {
        message: data.message,
        member: member,
        guid: data.publisher,
        channel: data.channel
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js